import { IListReqBody } from '@types';
import { axiosClient } from '@definitions';
import { AxiosResponse } from 'axios';
import { CertificationApiType, CertificationUserTestQuestionApiType } from '@api/types';
import { catchApiError } from '@utils';

export type GetCertificationsPayloadType = IListReqBody & {
  model: {
    role?: number[]
    state?: number[]
    managers?: string[]
  }
};
export const getCertifications = async (
  params: GetCertificationsPayloadType,
): Promise<CertificationApiType[]> => {
  try {
    const axios = axiosClient();
    const resp: AxiosResponse<CertificationApiType[]> = await axios.get(
      '/CertificationService/Certification/GetAvailableCertifications',
      { params },
    );
    return resp.data;
  } catch (e) {
    catchApiError(e);
  }
};

export type GetCertificationUserTestQuestionsPayloadType = IListReqBody & {
  model?: {
    idCertificationUserTest?: string
  }
};
export const getCertificationUserTestQuestions = async (
  params: GetCertificationUserTestQuestionsPayloadType,
): Promise<CertificationUserTestQuestionApiType[]> => {
  try {
    const axios = axiosClient();
    const resp: AxiosResponse<CertificationUserTestQuestionApiType[]> = await axios.post(
      '/CertificationService/CertificationUserTest/GetCertificationUserTestQuestions',
      params,
    );
    return resp.data;
  } catch (e) {
    catchApiError(e);
  }
};

export const deleteCertificationUserTests = async (params: { id: string }): Promise<void> => {
  try {
    const axios = axiosClient();
    const resp: AxiosResponse<void> = await axios.delete(
      `/CertificationService/CertificationUserTest/${params.id}/DeleteCertificationUserTest`,
    );
    return resp.data;
  } catch (e) {
    catchApiError(e);
  }
};
